import Vue from "vue";
import Vuex, { Store } from "vuex";
import state from "@/store/state";
import getters from "@/store/getters";
import actions from "@/store/actions";
import mutations from "@/store/mutations";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

const store = new Store({
  state,
  getters,
  actions,
  mutations,
  strict: debug,
});

export default store;
